import moment from "moment";
import { useTheme } from "../../../../../../context/ThemeContext";
import { useState } from "react";
import toast from "react-hot-toast";

export default function TransactionCard({ item }) {
  const { theme } = useTheme();
  const {
    withdrawal_id,
    payment_id,
    amount,
    mime_type,
    base64,
    type,
    msg,
    status,
    date_created,
    upi,
    account_number,
    account_name,
    account_ifsc,
    account_type,
    bank_name
  } = item;

  const [previewVisible, setPreviewVisible] = useState(false);

  const cellStyle = {
    flex: 1,
    textAlign: "center",
    fontWeight: 600,
    color: theme.text,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    fontSize: 12,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const handleViewSlip = (e) => {
    e.stopPropagation();
    if (!base64) return toast.error("No deposit slip found!");
    setPreviewVisible(true);
  };

  const handleStatusColor = () => {
    if (status == 1) return theme.buy; // success
    if (status == 2) return theme.sell; // canceled
    return theme.primary; // processing
  };

  const handleStatusText = () => {
    if (status == 1) return "SUCCESS";
    if (status == 2) return "REJECT";
    return "PROCESSING";
  };

  return (
    <>
      {/* Row Card */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: 48,
          padding: "0 12px",
          borderBottom: `1px solid ${theme.mode === "dark" ? "#333" : "#ddd"}`,
  
          transition: "background 0.2s",
        }}
      >
        {/* Transaction Type */}
        <div
          style={{
            ...cellStyle,
            color: payment_id ? theme.buy : theme.sell,
            flex: 1,
          }}
        >
          {payment_id ? "DEPOSIT" : withdrawal_id ? "WITHDRAWAL" : "-"}
        </div>

        {/* ID */}
        <div style={{ ...cellStyle, flex: 1 }}>
          {payment_id || withdrawal_id || "-"}
        </div>

        {/* Amount */}
        <div style={{ ...cellStyle, flex: 1 }}>
          ₹ {Number(amount || 0).toLocaleString("en-IN")}
        </div>

        {/* Deposit Slip */}
        <div style={{ ...cellStyle, flex: 1 }}>
          {type?.toLowerCase() === "deposit" && base64 ? (
            <button
              onClick={handleViewSlip}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
              }}
            >
              <img
                src={`data:${mime_type};base64,${base64}`}
                alt="Deposit Slip"
                style={{
                  height: 30,
                  borderRadius: 6,
                  boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                }}
              />
            </button>
          ) : (
            "-"
          )}
        </div>

        {/* Message */}
        <div style={{ ...cellStyle, flex: 1 }}>{msg || "-"}</div>
        <div style={{ ...cellStyle, flex: 1 }}>{upi || "-"}</div>
        <div style={{ ...cellStyle, flex: 1 }}>{account_number || "-"}</div>
        <div style={{ ...cellStyle, flex: 1 }}>{account_name || "-"}</div>
        <div style={{ ...cellStyle, flex: 1 }}>{account_ifsc || "-"}</div>
        <div style={{ ...cellStyle, flex: 1 }}>{account_type || "-"}</div>
        <div style={{ ...cellStyle, flex: 1 }}>{bank_name || "-"}</div>

        {/* Date */}
        <div style={{ ...cellStyle, flex: 1 }}>
          {moment(date_created).format("DD MMM YYYY, hh:mm A")}
        </div>

        {/* Status */}
        <div style={{ ...cellStyle, flex: 1 }}>
          <button
            style={{
              backgroundColor: handleStatusColor(),
              color: "#fff",
              border: "none",
              padding: "5px 10px",
              borderRadius: 6,
              fontWeight: 600,
              fontSize: 12,
              cursor: "pointer",
              minWidth: 90,
            }}
            onClick={() => {
              if (status == 0) toast("Transaction is processing...");
              if (status == 1) toast.success("Transaction successful!");
              if (status == 2) toast.error("Transaction cancelled!");
            }}
          >
            {handleStatusText()}
          </button>
        </div>
      </div>

      {/* Image Preview Modal */}
      {previewVisible && (
        <div
          onClick={() => setPreviewVisible(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.75)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
          }}
        >
          <img
            src={`data:${mime_type};base64,${base64}`}
            alt="Deposit Slip"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: 10,
              boxShadow: "0 0 20px rgba(0,0,0,0.5)",
            }}
          />
        </div>
      )}
    </>
  );
}
